import {
  periodColumnDefinition,
  fromCurrencyColumnDefinition,
  toCurrencyColumnDefinition,
  openSpotRateColumnDefinition,
  endSpotRateColumnDefinition,
  monthlyOperatingRateColumnDefinition,
  weightedAverageRateColumnDefinition,
  fromCurrencyPrecisionColumnDefinition,
  toCurrencyPrecisionColumnDefinition,
  updatedByColumnDefinition,
  lastUpdateDateColumnDefinition,
  diagnosticsSeverityColumnDefinition,
  diagnosticWithTooltipColumnDefinition,
  diagnosticColumnDefinition,
} from '../columnDefinitions';

export const currencyConversionRatesImportColDefs = [
  periodColumnDefinition,
  fromCurrencyColumnDefinition,
  toCurrencyColumnDefinition,
  openSpotRateColumnDefinition,
  endSpotRateColumnDefinition,
  monthlyOperatingRateColumnDefinition,
  weightedAverageRateColumnDefinition,
  fromCurrencyPrecisionColumnDefinition,
  toCurrencyPrecisionColumnDefinition,
];

const currencyConversionRateColumnDefinitions = [
  periodColumnDefinition,
  diagnosticsSeverityColumnDefinition,
  diagnosticWithTooltipColumnDefinition,
  fromCurrencyColumnDefinition,
  toCurrencyColumnDefinition,
  openSpotRateColumnDefinition,
  endSpotRateColumnDefinition,
  monthlyOperatingRateColumnDefinition,
  weightedAverageRateColumnDefinition,
  fromCurrencyPrecisionColumnDefinition,
  toCurrencyPrecisionColumnDefinition,
  updatedByColumnDefinition,
  lastUpdateDateColumnDefinition,
];

export default currencyConversionRateColumnDefinitions;

export const exportCurrencyConversionRateColumnDefinitions = [
  periodColumnDefinition,
  diagnosticsSeverityColumnDefinition,
  diagnosticColumnDefinition,
  ...currencyConversionRateColumnDefinitions.slice(3),
];
